<template>
	<div class="register">
		<div v-if="sendEmail === false" class="form">
			<div class="header5">User</div>
			<div class="header3">Registration</div>
			<div class="register-text">
				Registering with Garbur ensures that you stay up to date with the latest property tax news and you will automatically be notified if
				there is any change in our analysis of your property. Don’t miss out on the opportunity to save money on your taxes.
			</div>

			<div class="log-cont">
				<div class="paragraph question">Already have an account? <span @click="goLogin">Login here!</span></div>
			</div>

			<OrderForm :isConfirm="false" />
			<div class="button-cont">
				<Button title="Clear" buttonType="outline" type="reset" :onClick="clear" />
				<Button title="Register Now" :onClick="submit" />
			</div>
		</div>
		<div v-else class="thanks">
			<div class="email-cont">
				<img src="/svg/blob_test2.svg" alt="blah" class="second" />
				<img src="/svg/blob_test3.svg" alt="blah" class="third" />
				<img src="/svg/blob_test2.svg" alt="blah" class="fourth" />
				<img src="/svg/blob_test.svg" alt="blah" class="img-anime" />
			</div>
			<div class="cont-test">
				<div class="email-send accent">Thanks for choosing Garbur!</div>
				<div class="email-send white text-shadow">
					We have received your request and our team will contact you shortly to begin your appeal process.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

import OrderForm from "@/components/account/OrderForm.vue";
import Button from "@/components/ui/Button.vue";
import { AUTH_REGISTER } from "../store/constants";
import localData from "@/store/utils/localdata";
// https://github.com/mariomka/vue-datetime
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import api from "@/store/utils/api";

export default {
	name: "register",
	title: "Register",
	props: ["isConfirmProp"],
	components: {
		OrderForm,
		Button,
		datetime: Datetime,
	},
	data() {
		return {
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			password: "",
			address: "",
			pin: "",
			homePurchased: "No",
			purchaseDate: "",
			purchaseAmount: "",
			sendEmail: false,
			propertyId: 0,
			filingOption: null,
		};
	},
	mounted() {
		window.scrollTo(0, 0);

		if (this.currentData) {
			this.$store.commit("setOrderForm", {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				password: "",
				address: this.currentData.address,
				pin: this.currentData.pin,
				homePurchased: "No",
				purchaseDate: "",
				purchaseAmount: "",
			});
			this.filingOption = localData.getItem("filingOption");
		}
	},
	methods: {
		validate(user) {
			if (!user.email) {
				return {
					isValid: false,
					message: "Email is required",
				};
			}
			return {
				isValid: true,
			};
		},
		async submit() {
			const user = {
				firstName: this.formData.firstName,
				lastName: this.formData.lastName,
				email: this.formData.email,
				phone: this.formData.phone,
				password: this.formData.password,
				// propertyId: this.currentData.propertyId,
				filingOption: this.filingOption,
				// address: this.address,
				pin: this.formData.pin,
				// homePurchased: this.homePurchased === "Yes",
				// purchaseDate: this.formData.purchaseDate,
				// purchaseAmount: this.formData.purchaseAmount,
			};
			const validation = this.validate(user);
			if (!validation.isValid) {
				this.$toast.open({
					message: validation.message,
					position: "top",
					type: "error",
				});
				return;
			}

			try {
				const results = await this.$store.dispatch(AUTH_REGISTER, user);
				this.showEmailMessage();
			} catch (ex) {
				this.$toast.open({
					message: `Unable to register. ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
		},
		clear() {
			document.getElementById("register").reset();
			this.$router.push({ name: "Home" });
		},
		// goPayment() {
		// 	this.$router.push({ name: "Payment" });
		// },
		async confirm() {
			const user = {
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				phone: this.phone,
				propertyId: this.currentData.propertyId,
				filingOption: this.filingOption,
				// address: this.address,
				pin: this.pin,
				// homePurchased: this.homePurchased === "Yes",
				purchaseDate: this.purchaseDate,
				purchaseAmount: this.purchaseAmount,
			};
			try {
				const order = await api.post("/api/v1/orders/confirm", user);
				// this.$router.push({ name: "Payment", params: { id: order.id } });
				// @TODO need to ask about caseID and run locally or case.id
				// this.$router.push({ name: "Case", params: { id: caseId } });
				this.$router.push({ name: "Case", params: { id: order.id } });
			} catch (ex) {
				this.$toast.open({
					message: `Unable to confirm. ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
		},
		goConfirm() {
			this.$router.push({ name: "Confirm" });
			// eslint-disable-next-line vue/no-mutating-props
			this.isConfirm = true;
		},
		goLogin() {
			this.$router.push({ name: "Login" });
		},
		showEmailMessage() {
			this.sendEmail = true;
		},
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		currentData() {
			return JSON.parse(localData.getItem("currentData"));
		},
		formData() {
			// console.log("this.$store.getters.getOrderForm", this.$store.getters.getOrderForm);
			return this.$store.getters.getOrderForm;
			// return this.$store.state.property.orderFormData;
		},
	},
};
</script>

<style scoped lang="scss">
.register {
	.register-text {
		margin-top: 25px;
		max-width: 1000px;
	}

	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.question {
		// color: var(--black);
		// opacity: 0.5;
		color: rgba(22, 22, 22, 0.5);
		margin-top: 2px;
		span {
			font-style: normal;
			font-weight: 500;
			font-size: 18px;
			line-height: 27px;
			text-align: center;
			cursor: pointer;
			color: rgba(80, 205, 243, 1);
		}
		& :hover {
			color: var(--primary);
		}
	}
	.log-cont {
		margin-top: 2rem;
		margin-bottom: 1rem;
	}

	.button-cont {
		display: flex;
		flex-direction: row;
		// margin-top: 55px;
		.button {
			margin: 0 10px;
		}
	}
	.form {
		text-align: left;
		display: flex;
		flex-direction: column;
		padding: 65px 60px;
		max-width: 1650px;
	}

	.thanks {
		display: grid;

		.email-cont {
			background: var(--dark-blue);
			height: calc(100vh - 105px);
			position: relative;
			overflow: hidden;
		}
		.email-send {
			font-size: 36px;
			line-height: 84px;
			max-width: 1400px;
			position: relative;
		}
		.accent {
			color: var(--accent);
		}
		.white {
			color: var(--white);
		}
		.text-shadow {
			text-shadow: 2px 2px 3px black;
		}
		img.img-anime {
			position: absolute;
			width: 59%;
			top: 7vw;
			left: 11vw;
		}

		img.second {
			position: absolute;
			top: 200px;
			width: 20%;
			left: 86px;
			transform: rotate(45deg);
		}
		img.third {
			position: absolute;
			top: 350px;
			width: 45%;
			left: 61vw;
			// transform: rotate(45deg);
		}
		img.fourth {
			position: absolute;
			top: 69vh;
			width: 20%;
			left: 53vw;
			transform: rotate(57deg);
		}
		.cont-test {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 65%;
			margin: 0 auto;
			margin-top: 5rem;
		}
	}
	.thanks > div {
		grid-column-start: 1;
		grid-row-start: 1;
	}
}
@media (max-width: 450px) {
	.register {
		padding: 3rem 1rem;
	}
}
</style>
